import { Mutation } from '@apollo/client/react/components';
import React from 'react';
import { cancelVisit } from '../../../../graph/patients';

const withCancelVisitMutation = Component => props =>
  <Mutation mutation={cancelVisit}>{cancelVisit => <Component {...props} cancelVisit={cancelVisit} />}</Mutation>;

export default withCancelVisitMutation;
